import detailPagePlugin from "./plugins/detailPagePlugin"
import listPagePlugin from "./plugins/listPagePlugin"
import searchListPagePlugin from "./plugins/searchListPagePlugin"
import groupSearchListPagePlugin from "./plugins/groupSearchListPagePlugin"
import goBackPagePlugin from "./plugins/goBackPagePlugin"
import subPagePlugin from "./plugins/subPagePlugin"

export default {
  mixins: [detailPagePlugin, listPagePlugin, searchListPagePlugin, groupSearchListPagePlugin, goBackPagePlugin, subPagePlugin]
}
